import { SERVICE_AREAS } from "@/lib/collections";
import { MapPin, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function Zones() {
    return (
        <div>
            <section className="py-16 lg:py-24" style={{ background: "linear-gradient(160deg,#050F22,#0A2555)" }} data-theme="dark">
                <div className="max-w-4xl mx-auto px-5 lg:px-8">
                    <div className="eyebrow">Territoire</div>
                    <h1 className="font-serif text-4xl sm:text-5xl text-white mt-4">Zones desservies</h1>
                    <p className="text-white/75 mt-4">Un service local, humain et attentif, présent dans toute la Mauricie et les municipalités environnantes.</p>
                </div>
            </section>
            <section className="max-w-5xl mx-auto px-5 lg:px-8 py-14">
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
                    {SERVICE_AREAS.map(z => (
                        <div key={z} className="flex items-center gap-3 border border-kgd-gold/25 rounded-xl px-4 py-3 bg-white">
                            <MapPin className="w-4 h-4 text-kgd-gold"/>
                            <span className="text-[#071A33]">{z}</span>
                        </div>
                    ))}
                </div>
                <p className="text-slate-500 text-sm mt-6 italic">Votre municipalité n'est pas listée? Écrivez-nous — nous étudions les demandes environnantes au cas par cas.</p>
                <Link to="/soumission" className="btn-kgd mt-8 inline-flex" data-testid="zones-cta"><Sparkles className="w-4 h-4"/> Planifier mon évaluation gratuite</Link>
            </section>
        </div>
    );
}
